<template>
	<div v-scroll="handleScroll" v-if="allowed" style="overflow: auto">
		<v-overlay :class="{ mobile: mobile }" :style="navStyle" :value="mobile && active"></v-overlay>
		<v-navigation-drawer mini-variant-width="90" color="#072d52" height="100%" app v-model="active" hide-overlay
			disable-resize-watcher :style="drawerStyle">
			<v-row v-if="user && loggedIn" class="ma-0">
				<v-col class="pa-0" cols="12">
					<div style="width: 100%; margin-top: 5px; margin-bottom: 5px;" @click="openImageDialog('portrait')">
						<v-overlay absolute v-if="profilePictureUploading">
							Uploading Profile Picture
							<v-progress-circular indeterminate color="amber"></v-progress-circular>
						</v-overlay>
						<v-card flat style="background-color: transparent;">
							<BrebFile :file="user.profilePicture" ratio="photo" width="120px"
								:showPlaceHolder="AvatarPlaceholder"/>
						</v-card>
						<!-- <v-card v-else flat
							style="display: flex; justify-content: center; background-color: transparent;">
							<v-icon size="120" class="outlined-box">
								mdi-account
							</v-icon>
						</v-card> -->
					</div>
				</v-col>
			</v-row>

			<v-card flat class="breb-custom-scroll" style="border-radius: 0; background-color: #072d52;">
				<v-row v-if="loggedIn" class="ma-0" style="margin-right: 10px;">
					<v-col v-if="user" class="pa-0" cols="12">
						<div class="flex flex-wrap align-content-center justify-center welcome-background">
							<div style="width: 100%; text-align: center; color: white;">
								<h3 style="text-decoration: underline">
									Welcome to <span style="color: yellow">MyBREB</span>
								</h3>
							</div>
							<div style="width: 100%; text-align: center; color: white;">
								{{ user.firstName }} {{ user.lastName }}
							</div>
						</div>
					</v-col>
					<v-col v-if="!isStoragePlanOpen" cols="12" class="pa-0" style="background-color: white;">
						<v-card flat style="background-color: #4caf50; border-radius: 0;" @click="openStoragePlan">
							<v-divider class="ma-0" style="border-bottom: 2px solid white;"/>
							<v-row class="ma-0 pa-4" style="color: white;">
								<v-col class="pa-0 mr-4" cols="auto">
									<v-icon size="24" color="white">mdi-cloud-print-outline</v-icon>
								</v-col>
								MyAccount Status
							</v-row>
							<v-divider class="ma-0" style="border-bottom: 2px solid white;"/>
						</v-card>
					</v-col>
					<v-col v-else cols="12" class="pa-1" style="background-color: white; position: relative;">
						<v-btn class="close-btn" small @click="closeStoragePlan" outlined icon>
							<v-icon small>mdi-close</v-icon>
						</v-btn>
						<StoragePlan ref="storagePlan" isMenuBar/>
					</v-col>
				</v-row>

				<v-list dark class="pt-0 list-item-white">
					<v-list-item color="white" to="/dashboard/login" v-if="!loggedIn">
						<v-list-item-icon>
							<v-icon size="24">login</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								Sign In
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<!-- Home -->
					<v-list-item color="white" to="/" :style="{ 'border-top-width': !loggedIn ? '1px' : '' }">
						<v-list-item-icon>
							<v-icon size="24">other_houses</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								Home
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<!-- About -->
					<v-list-item color="white" to="/about" style="border-top-width: 1px;">
						<v-list-item-icon>
							<v-icon size="24">info</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								About
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<!-- <v-list-item v-if="loggedIn && hasPartnerCreate && !partnerConnected"
						@click="navigateStripeOauthInit" style="border-top-width: 1px;">
						<v-list-item-icon>
							<v-icon size="24" color="yellow">mdi-currency-usd</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title style="color: yellow">Connect to Stripe</v-list-item-title>
						</v-list-item-content>
					</v-list-item> -->

					<v-list-item v-if="!loggedIn" color="white" to="/merchantIntroduction"
						style="border-top-width: 1px;">
						<v-list-item-icon>
							<v-icon size="24">other_houses</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								Become a Merchant
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<!-- Free Profile -->
					<v-list-group no-action class="row-fix list-item-white-bordered" color="white"
						group="/dashboard/free-profile">
						<template v-slot:prependIcon>
							<v-icon size="24">mdi-card-account-details-outline</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									<span style="color: yellow;">FREE</span>
									Profile Page
								</v-list-item-title>
							</v-list-item-content>
						</template>
						<!-- Realtor Profile -->
						<v-list-item color="white" @click="navigateToRealtorProfile" style="border-top-width: 1px;"
							class="list-subitem" exact-path>
							<v-list-item-icon>
								<v-icon size="24">real_estate_agent</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px;">
									<span style="color: yellow;">FREE</span>
									Realtor Profile
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Brokerage Profile -->
						<v-list-item color="white" @click="navigateToBrokerageIntroduction"
							style="border-top-width: 1px;" class="list-subitem" exact-path>
							<v-list-item-icon>
								<v-icon size="24">mdi-account-group</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px;">
									<span style="color: yellow;">FREE</span>
									Brokerage Profile
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Brokerage Profile -->
						<v-list-item color="white" @click="navigateToCityProfileIntroduction"
							style="border-top-width: 1px;" class="list-subitem" exact-path>
							<v-list-item-icon>
								<v-icon size="24">mdi-home-city</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px;">
									<span style="color: yellow">MyCity</span>
									Profile & Directory
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- Profile -->
					<v-list-item color="white" v-if="user && loggedIn" to="/dashboard/profile">
						<v-list-item-icon>
							<v-icon size="24">account_circle</v-icon>
						</v-list-item-icon>
						<v-list-item-title>
							MyBREB Account
						</v-list-item-title>
					</v-list-item>

					<!-- My favourites -->
					<v-list-item style="position: relative" to="/dashboard/bookmarks">
						<v-list-item-icon>
							<v-icon size="24">mdi-cards-heart</v-icon>
						</v-list-item-icon>
						<v-list-item-title>
							Favourites
						</v-list-item-title>
					</v-list-item>

					<!-- Notifications -->
					<!-- <v-list-item style="position: relative" to="/dashboard/notifications/list">
						<v-list-item-icon>
							<v-icon size="24">mdi-message-badge</v-icon>
						</v-list-item-icon>
						<v-list-item-title>Notifications</v-list-item-title>
					</v-list-item> -->

					<!-- Alerts -->
					<v-list-item style="position: relative" to="/dashboard/alerts">
						<v-list-item-icon>
							<v-icon size="24">mdi-bell</v-icon>
						</v-list-item-icon>
						<v-list-item-title style="position:relative; overflow: visible; padding-top: 15px;">
							<v-badge :value="matchedNumber" color="red" class="pa-0 ma-0" style="top: -8px;">
								<template v-slot:badge>
									{{ matchedNumber > 9 ? '9+' : matchedNumber }}
								</template>
								<span>
									Alerts
								</span>
							</v-badge>
						</v-list-item-title>
					</v-list-item>

					<!-- User Listings -->
					<v-list-group v-if="user && loggedIn" no-action class="row-fix list-item-white-bordered"
						color="white" group="/dashboard/listing">
						<template v-slot:prependIcon>
							<v-icon size="24">mdi-view-list-outline</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									User Listings
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="user && loggedIn" color="white" to="/dashboard/listings" class="list-subitem"
							exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-format-list-group</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									MyListings
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/listing/post" class="list-subitem">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-playlist-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Post <span style="color: yellow">FREE</span> Listing
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- Marketplace -->
					<v-list-group v-if="user && loggedIn" no-action class="row-fix list-item-white-bordered"
						v-show="false"
						color="white" group="/dashboard/marketplace">
						<template v-slot:prependIcon>
							<v-icon size="24">mdi-shopping</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									eMarketplace
								</v-list-item-title>
							</v-list-item-content>
						</template>
						<!-- Shopping Cart -->
						<v-list-item color="white" to="/dashboard/marketplace/cart" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">shopping_cart</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									MyShopping Cart
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<!-- Order -->
						<v-list-item color="white" to="/dashboard/marketplace/orders" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-order-bool-ascending</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									MyPurchase Orders
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- Merchant/Sponsor -->
					<v-list-group v-if="loggedIn && isAppliedMerchant" no-action
						class="row-fix list-item-white-bordered" color="white" group="/dashboard/merchant"
						:value="activeLevel(`/dashboard/merchant`)">
						<template v-slot:prependIcon>
							<v-icon size="24">business_center</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content style="flex-grow: 1;">
								<v-list-item-title style="font-size: 15px;">
									Merchants/Sponsors
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<!-- Marketplace registration -->
						<v-list-item color="white" to="/dashboard/merchant/advertising" class="list-subitem" exact-path
							:value="activeLevel(`/dashboard/merchant/advertising`)">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-store-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Manage Advertising
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Marketplace registration -->
						<v-list-item color="white" to="/dashboard/merchant/marketplace/registration"
							v-if="!hasShop"
							class="list-subitem" exact-path
							:value="activeLevel(`/dashboard/merchant/marketplace/registration`)">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-store-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Become an eSeller
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Merchant Dashboard -->
						<v-list-item color="white" to="/dashboard/merchant/dashboard" class="list-subitem" exact-path
							:value="activeLevel(`/dashboard/merchant/dashboard`)">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-view-dashboard</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Merchant Dashboard
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Marketplace registration -->
						<!-- <v-list-item v-if="shops && shops.length" color="white" @click="clickPostProduct"
							class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-archive-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Post/Sell Product
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item> -->
						<!-- Shops -->
						<v-list-group v-if="shops.length" no-action sub-group
							group="/dashboard/merchant/marketplace/shops" style="background-color: #0b4073;"
							color="white" class="shops-group"
							:value="clickedPostProduct || activeLevel(`/dashboard/merchant/marketplace/shops`)">
							<template v-slot:prependIcon>
								<v-icon size="18">mdi-store-search</v-icon>
							</template>
							<template v-slot:appendIcon>
								<v-icon size="18">keyboard_arrow_down</v-icon>
							</template>
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title style="font-size: 14px">
										eStore(s)
									</v-list-item-title>
								</v-list-item-content>
							</template>

							<!-- eStore list-->
							<v-list-group no-action sub-group
								:group="`/dashboard/merchant/marketplace/shops/shop/${shop.id}`"
								style="background-color: #5d8cb9;" color="white" v-for="(shop) in shops" :key="shop.id"
								class="shop-group"
								:value="activeLevel(`/dashboard/merchant/marketplace/shops/shop/${shop.id}`)"
								@click="clickShop(shop)">
								<template v-slot:prependIcon>
									<v-icon size="18">mdi-store</v-icon>
								</template>
								<template v-slot:appendIcon>
									<v-icon size="24">keyboard_arrow_down</v-icon>
								</template>
								<template v-slot:activator>
									<v-list-item-content>
										<v-list-item-title style="font-size: 14px">
											{{ shop.name }}
										</v-list-item-title>
									</v-list-item-content>
								</template>
								<v-list-item color="white"
									:to="`/dashboard/merchant/marketplace/shops/shop/${shop.id}/summary`"
									style="background-color: #4695ed;" exact-path>
									<v-list-item-icon class="mr-3">
										<v-icon size="18">mdi-store-settings</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title style="font-size: 14px">
											Summary
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item color="white"
									:to="`/dashboard/merchant/marketplace/shops/shop/${shop.id}/invoices`"
									style="background-color: #4695ed;" exact-path>
									<v-list-item-icon class="mr-3">
										<v-icon size="18">mdi-invoice-multiple</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title style="font-size: 14px">
											Invoices
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item color="white"
									:to="`/dashboard/merchant/marketplace/shops/shop/${shop.id}/products`"
									style="background-color: #4695ed;" exact-path>
									<v-list-item-icon class="mr-3">
										<v-icon size="18">mdi-list-box-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title style="font-size: 14px">
											Products
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item color="white"
									:to="`/dashboard/merchant/marketplace/shops/shop/${shop.id}/setting`"
									style="background-color: #4695ed;" exact-path>
									<v-list-item-icon class="mr-3">
										<v-icon size="18">mdi-store-cog-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title style="font-size: 14px">
											Settings
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-group>
						</v-list-group>
					</v-list-group>

					<!-- Brokerages -->
					<v-list-group no-action class="row-fix list-item-white-bordered" color="white"
						group="/dashboard/brokerage">
						<template v-slot:prependIcon>
							<v-icon size="24">mdi-account-group</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									Brokerages
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-if="user && loggedIn" color="white" to="/dashboard/brokerage/list"
							class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-account-multiple-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									MyBrokerages
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item color="white" to="/search/brokerage" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-account-search</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Find Brokerages
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- Notifications -->
					<v-list-group v-if="loggedIn" no-action class="row-fix list-item-white-bordered" color="white"
						group="/dashboard/notifications">
						<template v-slot:prependIcon>
							<v-icon size="24">mdi-chat</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title style="position:relative; overflow: visible; padding-top: 15px;">
									<v-badge :value="notificationsUnread" color="red" class="pa-0 ma-0"
										style="top: -8px;">
										<template v-slot:badge>
											{{ notificationsUnread > 9 ? '9+' : notificationsUnread }}
										</template>
										<span>
											Messages
										</span>
									</v-badge>
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item color="white" to="/dashboard/notifications/list" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-chat-processing</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									style="font-size: 14px; position:relative; overflow: visible; padding-top: 15px;">
									<v-badge :value="notificationsUnread" color="red" class="pa-0 ma-0"
										style="top: -10px;">
										<template v-slot:badge>
											{{ notificationsUnread > 9 ? '9+' : notificationsUnread }}
										</template>
										<span>
											MyChat
										</span>
									</v-badge>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/notifications/ignored" class="list-subitem"
							exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-account-cancel</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Blocked Users
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- Partner -->
					<v-list-group v-if="loggedIn && hasPartnerCreate" no-action class="row-fix list-item-white-bordered"
						color="white">
						<template v-slot:prependIcon>
							<v-icon size="24">mdi-handshake</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									Managers
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item color="white" to="/dashboard/paymentProcessors" class="list-subitem">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-account-credit-card-outline</v-icon>
							</v-list-item-icon>
							<v-list-item-content style="font-size: 14px">
								Connect To Stripe
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/manager-account" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-ticket-percent</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Manager Coupons
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item color="white" to="/dashboard/manager-invitation" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">email</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Invitation Emails
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- User Settings -->
					<v-list-group v-if="loggedIn" no-action class="row-fix list-item-white-bordered" color="white">
						<template v-slot:prependIcon>
							<v-icon size="24">settings</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									Settings
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<!-- Plan Subscription -->
						<v-list-item color="white" to="/dashboard/plan-subscription" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-package</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Plan Subscription
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- File Management -->
						<v-list-item color="white" to="/dashboard/file-management" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-multimedia</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									File Management
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/stripe" class="list-subitem" v-if="user && loggedIn">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-credit-card-outline</v-icon>
							</v-list-item-icon>
							<v-list-item-content style="font-size: 14px">
								Billing
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/security" class="list-subitem" exact-path v-if="user">
							<v-list-item-icon class="mr-5">
								<v-icon size="18">security</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Security
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!-- Administration Zone -->
					<v-list-group v-if="loggedIn && isAdministratorGroup" no-action
						class="row-fix list-item-white-bordered" color="white" group="/dashboard/admin">
						<template v-slot:prependIcon>
							<v-icon size="24">admin_panel_settings</v-icon>
						</template>
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>
									Manage MyBREB
								</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item color="white" to="/dashboard/admin/zones" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-select-marker</v-icon>
							</v-list-item-icon>
							<v-list-item-title style="font-size: 14px">
								BREB Advertising
							</v-list-item-title>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/admin/homepage" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">public</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Homepage
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/admin/users" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">supervisor_account</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									User Management
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/admin/listings" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-format-list-bulleted</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Listing Management
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- <v-list-item color="white" to="/dashboard/admin/stripe" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">savings</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">Stripe Settings</v-list-item-title>
							</v-list-item-content>
						</v-list-item> -->

						<v-list-item color="white" to="/dashboard/admin/invitation" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">security</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Permission Invitation
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/admin/plan" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-package</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Plan Management
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item color="white" to="/dashboard/admin/coupon" class="list-subitem" exact-path>
							<v-list-item-icon class="mr-5">
								<v-icon size="18">mdi-ticket-percent</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title style="font-size: 14px">
									Coupon Management
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>

					<!--Signin/Signout -->
					<v-list-item color="white" @click="logout" v-if="loggedIn">
						<v-list-item-icon>
							<v-icon size="24">logout</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								Sign Out
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-card>

			<!-- Login/Logout -->
			<template v-slot:append>
				<v-list dark class="pa-0">

				</v-list>
			</template>

		</v-navigation-drawer>
		<v-dialog :width="700" v-if="cropperDialog" v-model="cropperDialog" retain-focus persistent
			transition="dialog-bottom-transition" :fullscreen="$vuetify.breakpoint.xs">
			<v-card>
				<v-card-text class="pa-2">
					<BrebCropper :title="cropper.title" :uploadType="cropper.type" @closeCopper="closeCopper"
						@uploadSuccess="uploadSuccess"/>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import BrebCropper from "@/components/accessory/BrebCropper"
import BrebFile from "@/components/accessory/BrebFile.vue";
import StoragePlan from "@/components/storage/StoragePlan.vue";
import AvatarPlaceholder from '@/assets/default-images/user.png';

const emitter = require("tiny-emitter/instance");

export default {
	components: {
		BrebCropper,
		BrebFile,
		StoragePlan,
	},
	data: function () {
		return {
			triggered: false,
			navOffset: 0,
			profilePictureUploading: false,
			redirectKey: "redirect-key",
			cropperDialog: false,
			cropper: {
				title: null,
				type: null,
			},
			isStoragePlanOpen: true,
			AvatarPlaceholder,
			emitter,
			activeShop: null,
			clickedPostProduct: false,
			pollingInterval: null,
		}
	},
	computed: {
		bookmarksTotalElements() {
			return this.$store.getters["api/bookmarks/getTotalElements"];
		},
		// partnerConnected() {
		// 	return this.$store.getters['api/stripe/getStripeAuthenticated'];
		// },
		active: {
			set: function (v) {
				this.triggered = v;
			},
			get: function () {
				if (this.mobile) {
					return this.triggered;
				} else {
					return this.allowed;
				}
			}
		},
		navStyle: function () {
			return {
				top: Math.max(0, this.$vuetify.application.top - this.navOffset) + 'px',
				zIndex: 4
			}
		},
		shops() {
			return this.$store.getters['api/shop/getShops'];
		},
		user: function () {
			return this.$store.getters['user/getUser'];
		},
		isAppliedMerchant() {
			return this.user?.merchantApplication;
		},
		loggedIn: function () {
			return this.$store.getters['user/getLoggedIn'];
		},
		isAdministratorGroup() {
			return this.$helpers.isAdministratorGroup(this.$store);
		},
		hasPartnerCreate: function () {
			return this.$helpers.hasPartnerCreate(this.$store);
		},
		drawerStyle: function () {
			return {
				"padding-top": Math.max(0, this.$vuetify.application.top - this.navOffset) + 'px',
				zIndex: 5,
			}
		},
		mobile() {
			return this.$vuetify.breakpoint.mobile;
		},
		allowed() {
			let meta = this.$route.meta;

			// Only named routes are allowed to nav
			if (!this.$route.name) {
				return false;
			}

			// Mobile can navigate from anywhere
			if (this.mobile) {
				return true;
			}

			if (this.$route.path.startsWith('/dashboard')) {
				// Otherwise, static navigation has some restrictions
				if ('navigationAllowed' in meta) {
					return meta.navigationAllowed
				} else {
					return true;
				}
			} else {
				return false;
			}
		},
		notificationsUnread() {
			return this.$store.getters["api/inbox/getUnreadCount"];
		},
		matchedNumber() {
			return this.$store.getters['api/rule/getHasNewMatched'];
		},
		isActiveShop() {
			return (shopId) => {
				return this.$route.path.startsWith(`/dashboard/merchant/marketplace/shops/shop/${shopId}`);
			};
		},
		activeLevel() {
			return (path) => this.$route.path.startsWith(path);
		},
		hasShop() {
			return this.$store.getters["api/shop/getShops"]?.length > 0;
		},
	},
	watch: {
		'active': function (v) {
			this.toggleScrollLock(v && this.mobile)
		},
		'mobile': function (v) {
			this.toggleScrollLock(v && this.active)
		},
		'$route.path': {
			handler(newPath) {
				this.expandActiveShop(newPath);
			},
			immediate: true
		},
	},
	methods: {
		// navigateStripeOauthInit() {
		// 	localStorage.setItem(
		// 		this.redirectKey,
		// 		JSON.stringify({
		// 			action: "partner_application",
		// 		})
		// 	);
		// 	window.location = `${window.location.origin}/api/v1/stripe/oauth/authorize`
		// },
		navigateToRealtorProfile() {
			if (this.$route.fullPath !== '/realtorIntroduction') {
				this.$router.push({path: '/realtorIntroduction'});
			}
		},
		navigateToBrokerageIntroduction() {
			if (this.$route.fullPath !== '/brokerageIntroduction') {
				this.$router.push({path: '/brokerageIntroduction'});
			}
		},
		navigateToCityProfileIntroduction() {
			if (this.$route.fullPath !== '/cityProfileIntroduction') {
				this.$router.push({path: '/cityProfileIntroduction'});
			}
		},
		clickUserListings() {
			if (this.$route.path !== '/dashboard/listings') {
				this.$router.push({path: '/dashboard/listings'});
			}
		},
		clickMarketplace() {
			if (this.$route.path !== '/dashboard/marketplace/cart') {
				this.$router.push({path: '/dashboard/marketplace/cart'});
			}
		},
		clickMerchantsSponsors() {
			if (this.$route.path !== '/dashboard/merchant/dashboard') {
				this.$router.push({path: '/dashboard/merchant/dashboard'});
			}
		},
		// goPlanSubscription() {
		// 	if (this.isAppliedMerchant) {
		// 		this.$router.replace({ path: '/dashboard/merchant/dashboard' });
		// 	} else {
		// 		this.$router.replace({ path: '/dashboard/plan-subscription' });
		// 	}
		// },
		clickBrokerages() {
			if (this.$route.path !== '/dashboard/brokerage/list') {
				this.$router.push({path: '/dashboard/brokerage/list'});
			}
		},
		clickMessages() {
			if (this.$route.path !== '/dashboard/notifications/list') {
				this.$router.push({path: '/dashboard/notifications/list'});
			}
		},
		clickManagers() {
			if (this.$route.path !== '/dashboard/paymentProcessors') {
				this.$router.push({path: '/dashboard/paymentProcessors'});
			}
		},
		handleScroll() {
			this.navOffset = window.scrollY;
		},
		trigger() {
			this.triggered = true;
		},
		logout() {
			this.triggered = false;
			this.emitter.emit('logoutUser');
		},
		toggleScrollLock: function (locked) {
			if (locked)
				document.documentElement.classList.add('overflow-y-hidden');
			else
				document.documentElement.classList.remove('overflow-y-hidden')
		},
		openPictureSelectDialog() {
			this.$refs.fileSelect.$refs.input.click();
		},
		updateUserProfile(file) {
			this.profilePictureUploading = true;

			// Copy the user object and modify it
			let userObject = Object.assign({}, this.user);
			userObject.profilePicture = file;

			// Send the request, update the current user object.
			this.$axios.put("/api/v1/user/", userObject).then(() => {
				this.$store.dispatch("user/getUser");
			}).catch(() => {

			}).finally(() => {
				this.profilePictureUploading = false;
			});
		},
		uploadSuccess(file) {
			if (file) {
				this.updateUserProfile(file);
				this.$toasted.success("Updated user profile picture successfully.");
				this.startQuarantineCheck(file);
			} else {
				this.$toasted.error("Could not update user profile picture. ");
			}
		},
		startQuarantineCheck(file) {
			const isImage = file.mime_type.startsWith('image/')
			const checkInterval = isImage ? 2000 : 15000;
			const maxAttempts = isImage ? 30 : 20;
			let attempts = 0;

			const checkStatus = () => {
				attempts++;
				this.$store.dispatch('api/file/getFileById', {fileId: file.id}).then(response => {
					if (response.status === 200) {
						if (!response.data.quarantined) {
							if (this.user?.profilePicture?.id === response.data.id) {
								this.updateUserProfile(response.data);
							}
							this.clearUploadInterval();
						} else if (attempts >= maxAttempts) {
							this.updateUserProfile(null);
							this.$toasted.error('The image did not meet standard policy. Please upload an appropriate image.');
							this.clearUploadInterval();
						}
					}
				}).catch(() => {
					this.updateUserProfile(null);
					this.$toasted.error('The image did not meet standard policy. Please upload an appropriate image.');
					this.clearUploadInterval();
				});
			};

			this.pollingInterval = setInterval(checkStatus, checkInterval);
		},
		clearUploadInterval() {
			clearInterval(this.pollingInterval);
			this.pollingInterval = null;
		},
		// toShopSection(section, shop) {
		// 	if (this.$route.path !== `/dashboard/merchant/marketplace/shops/shop/${shop.id}/${section}`) {
		// 		this.$router.push({
		// 			path: `/dashboard/merchant/marketplace/shops/shop/${shop.id}/${section}`,
		// 			query: {

		// 			}
		// 		})
		// 	}
		// },
		openCopper(title, type) {
			this.cropper.title = title;
			this.cropper.type = type;
			this.cropperDialog = true;
		},
		closeCopper() {
			this.cropper.title = null;
			this.cropper.type = null;
			this.cropperDialog = false;
		},
		openImageDialog(type) {
			this.openCopper('Upload MyBREB Photo', 'photo');
		},
		openStoragePlan() {
			this.isStoragePlanOpen = true;
		},
		closeStoragePlan() {
			this.isStoragePlanOpen = false;
		},
		goMerchantDashboard() {
			if (this.$route.fullPath !== '/dashboard/merchant/dashboard') {
				this.$router.push({path: '/dashboard/merchant/dashboard'});
			}
		},
		expandActiveShop(newPath) {
			this.shops.forEach((shop) => {
				if (newPath.startsWith(`/dashboard/merchant/marketplace/shops/shop/${shop.id}`)) {
					this.activeShop = shop.id;
				}
			});
		},
		// clickPostProduct() {
		// 	if (this.shops.length === 1) {
		// 		if (this.$route.fullPath !== '/dashboard/merchant/marketplace/product/post') {
		// 			this.$router.push({
		// 				path: '/dashboard/merchant/marketplace/product/post',
		// 				query: {
		// 					shopId: this.shops[0].id,
		// 				}
		// 			});
		// 		}
		// 		this.clickedPostProduct = false;
		// 	} else {
		// 		this.$toasted.show(`Please select the shop that you want to post product under My-eStore(s) section.`)
		// 		this.clickedPostProduct = true;
		// 	}
		// },
		clickShop(shop) {
			if (this.clickedPostProduct) {
				if (this.$route.fullPath !== '/dashboard/merchant/marketplace/product/post') {
					this.$router.push({
						path: '/dashboard/merchant/marketplace/product/post',
						query: {
							shopId: shop.id,
						}
					});
				}
			}
			this.clickedPostProduct = false;
		}
	},
	mounted: function () {
		this.toggleScrollLock(this.active && this.mobile);
	},
	beforeDestroy() {
		if (this.pollingInterval) {
			this.clearUploadInterval();
		}
	},
}
</script>

<style lang="scss" scoped>
.close-btn {
	position: absolute;
	z-index: 1;
	right: 4px;
	top: 6px;
	color: #cccccc;
	background-color: #cccccc;
	border: solid 0px black;
}

.welcome-background {
	background-color: var(--v-accent-lighten1);
	width: 100%;
	height: 60px;
	display: flex;
}

// ::v-deep .v-menu__content {
// 	max-height: 300px !important;
// }


::v-deep .v-select input::placeholder {
	color: black !important;
	opacity: 1 !important;
	font-size: 14px;
}
</style>

<style scoped>
/*
	>>> .v-list-item.v-list-item--active {
		color: yellow!important;
	}
	**/

>>> .v-list-group--disabled {
	background-color: darkgrey;
}

.list-subitem {
	background-color: #0b4073;
	padding-left: 32px !important;
}

.list-item-white >>> .v-list-item {
	border-color: white;
	border-style: solid;
	border-top-width: 0;
	border-bottom-width: 1px;
	border-left-width: 0;
	border-right-width: 0;
}

.list-item-white >>> .v-list-item:hover {
	background-color: #376386;
}

.list-item-white >>> .list-subitem {
	background-color: #376386;
}

.row-fix >>> .v-list-group__header {
	flex-direction: row !important;
}

.list-item-white-bordered {
}

.nav-clamped {
	max-width: 300px;
}

.nav-clamped.mobile {
	height: 100vh;
}

::v-deep .v-list-item__icon {
	margin-right: 15px !important;
}

::v-deep .v-list-group__header__prepend-icon {
	margin-right: 15px !important;
}

::v-deep .v-list-group__header__append-icon {
	margin-left: -20px !important;
	margin-right: 0px !important;
}

.v-list-group__header .v-list-group__header__prepend-icon i {
	transform: rotate(0deg) !important;
	transition: none !important;
}

.shop-group .v-list-group__items .v-list-item {
	padding-left: 48px !important;
}
</style>